
<script>
    import { createEventDispatcher } from 'svelte';
    import { breakpoint } from '../componentes/MediaQuery.svelte';
    import { postData } from '../scripts';
    import { urlapi } from '../stores/store';
    
    export let lote={};

    let campoproveedor=null;

    const dispatch = createEventDispatcher();

    let limpiar=function() {
        lote.fechacompra=new Date().toISOString().substring(0, 10);
        lote.proveedor='';
        lote.referencia='';
        lote.observaciones='';
        campoproveedor.focus();
    }

    function validate() {
		lote.activo=false;
	}

    let editar=function() {
        lote.activo=true;
    }

    let timer=null;

    function Enter(e,campo)
    {
        let charCode = (e.which) ? e.which : e.keyCode
        if(timer!==null) clearTimeout(timer);
        timer=setTimeout(function() { buscarNIT() },500)
        if(charCode == 13){ buscarNIT() }
        return true;
    }

</script>


<div class="card mt-2 mb-2" >

    {#if lote.activo===true}
        <div class="card-header">
            DATOS DEL LOTE
        </div>    
        <form on:submit|preventDefault={validate}>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                        <div class="form-floating">
                            <!-- svelte-ignore a11y-autofocus -->
                            <input type="date" class="form-control form-control-sm" id="floatnit" placeholder="NIT" bind:value={lote.fechacompra} required>
                            <label for="floatnit" class='text-secondary'>FECHA COMPRA</label>
                        </div>          
                </li>
                <li class="list-group-item">
                        <div class="form-floating">
                            <input type="text" class="form-control form-control-sm" id="floatnombre" placeholder="NOMBRE" bind:value={lote.proveedor} required autofocus bind:this={campoproveedor}>
                            <label for="floatnombre" class='text-secondary'>PROVEEDOR</label>
                        </div>
                </li>
                <li class="list-group-item">
                        <div class="form-floating">
                            <input type="text" class="form-control form-control-sm" id="floatdireccion" placeholder="REFERENCIA" bind:value={lote.referencia} required>
                            <label for="floatdireccion" class='text-secondary'>REFERENCIA</label>
                        </div>
                </li>

                <li class="list-group-item">
                    <div class="form-floating">
                        <input type="text" class="form-control form-control-sm" id="floatdireccion" placeholder="OBSERVACIONES" bind:value={lote.observaciones}>
                        <label for="floatdireccion" class='text-secondary'>OBSERVACIONES</label>
                    </div>
                </li>                

                <li class="list-group-item">
                        <button type="submit" 
                            class:btn-lg={$breakpoint === 'xxl'}
                            class:btn-sm={$breakpoint !== 'xxl'}
                            class='btn btn-success me-3'><i class="bi bi-caret-up-fill"></i>
                        </button>

                        <div class="float-end mt-1">
                            <button type="button"
                                class:btn-lg={$breakpoint === 'xxl'}
                                class:btn-sm={$breakpoint !== 'xxl'}                            
                                on:click={limpiar} class='btn btn-danger me-1'><i class="bi bi-trash me-1"></i>LIMPIAR
                            </button>
                        </div>
                </li>
            </ul>
        </form>
    {:else}
        <div class="card-header">
            <button type="button"
                class:btn-lg={$breakpoint === 'xxl'}
                class:btn-sm={$breakpoint !== 'xxl'}            
                on:click={editar} class='btn btn-warning float-end'><i class="bi bi-caret-down-fill"></i>
            </button>
            <div class='row'>
                <div class="col-3"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>FECHA COMPRA:</small><br/><strong>{lote.fechacompra}</strong></p></div>
                <div class="col-6"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>PROVEEDOR:</small><br/><strong>{lote.proveedor}</strong></p></div>
                <div class="col-12"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>REFERENCIA:</small><br/><strong>{lote.referencia}</strong></p></div>
                <div class="col-12"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>OBSERVACIONES:</small><br/><strong>{lote.observaciones}</strong></p></div>
            </div>
        </div>
    {/if}

</div>



                                